import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const EnquirePurchaseSticky: StyleRule = ({ theme }) => ({
    background: theme.siteVariables.colors.white['100A'],
    padding: pxArrayToRem([14, 0]),

    [`& .purchase-group`]: {
        margin: pxArrayToRem([0, 18]),
    },
    [`& .sample-purchase`]: {
        padding: 0,
        margin: pxArrayToRem([0, 18]),
    },
});
